import {put} from "redux-saga/effects";

const actionFactories = {
    init: (host) => ({ host }),
    serviceWorkerRegistered: (registration) => ({registration}),
    serviceWorkerUpdateReady: () => ({}),
    settingsLoaded: (settings) => ({settings}),
    settingsChanged: (changes) => ({changes}),
    userChanged: () => ({}),
    logout: () => ({}),
    timeChanged: (time) => ({time}),
    saveClickedChanged: (saveClicked) => ({saveClicked}),
    selectedCommunityChanged: (selectedCommunity) => ({selectedCommunity}),

    postsLoaded: (posts) => ({posts}),

    feedLoaded: (key, posts, more) => ({key, posts, more}),
    feedPolled: (key, posts) => ({key, posts}),
    feedLoadReset: (key) => ({key}),
    feedLoading: (key) => ({key}),
    feedTailLoaded: (key, posts, more) => ({key, posts, more}),
    feedTailLoadFailed: (key) => ({key}),
    feedsCleared: (sort) => ({sort}),

    commentsLoaded: (comments) => ({comments}),
    commentListLoading: (key) => ({key}),
    commentListLoaded: (key, ids, comments, more) => ({key, ids, comments, more}),
    commentListExtended: (key, ids, comments, page, more) => ({key, ids, comments, page, more}),
    commentListLoadFailed: (key) => ({key}),

    contentListLoading: (key) => ({key}),
    contentListLoaded: (key, content, more) => ({key, content, more}),
    contentListPolled: (key, content) => ({key, content}),
    contentListExtended: (key, content, more) => ({key, content, more}),
    contentListLoadFailed: (key) => ({key}),

    communityListLoaded: (sort, communities, timestamp) => ({sort, communities, timestamp}),
    communitiesLoaded: (communities, timestamp) => ({communities, timestamp}),
    postVoteChanged: (id, voteState) => ({id, voteState}),
    postHiddenChanged: (id, hidden) => ({id, hidden}),
    postEdited: (id, content) => ({id, content}),
    postDeleted: (id) => ({id}),
    postNsfw: (id, newState) => ({id, newState}),
    postModDistinguished: (id, newState) => ({id, newState}),
    postSticky: (id, newState) => ({id, newState}),
    postLock: (id, newState) => ({id, newState}),
    postRemove: (id, moderator) => ({id, moderator}),
    postApprove: (id, moderator) => ({id, moderator}),
    postIgnoreReports: (id, ignoreReports) => ({id, ignoreReports}),
    commentCreated: (comment) => ({comment}),
    commentEdited: (id, content) => ({id, content}),
    commentVoteChanged: (id, voteState) => ({id, voteState}),
    commentDeleted: (id) => ({id}),
    commentModDistinguished: (id, newState) => ({id, newState}),
    commentSticky: (id, newState) => ({id, newState}),
    commentRemove: (id, moderator) => ({id, moderator}),
    commentApprove: (id, moderator) => ({id, moderator}),
    commentIgnoreReports: (id, ignoreReports) => ({id, ignoreReports}),

    savedFeedsLoaded: (feeds) => ({feeds}),
    savedFeedsRemoved: (id) => ({id}),
    savedFeedsAdded: (feed) => ({feed}),
    savedFeedsUpdated: (feed) => ({feed}),

    adConsumerAdded: () => ({}),
    adConsumerRemoved: () => ({}),
    adConfigChanged: (config) => ({config}),
    adUnitsChanged: (units) => ({units}),

    feedStateChanged: (key, data) => ({key, data}),
    feedAdUnitsChanged: (key, index, data) => ({key, index, data}),
    feedAdUnitsCleared: (key) => ({key}),

    googleAdsEnabledChanged: (value) => ({value}),
};

export const actionEffects = {};
Object.keys(actionFactories).forEach((key) => {
    const actionFactory = actionFactories[key];
    actionEffects[key] = (...args) => put({type: key, payload: actionFactory(...args)});
});

export function bindActions(store) {
    const actions = {};
    Object.keys(actionFactories).forEach((key) => {
        const actionFactory = actionFactories[key];
        actions[key] = (...args) => store.dispatch({ type: key, payload: actionFactory(...args) });
    });
    return actions;
}
